import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useIntl } from 'react-intl';
import TagItems from './components/TagItems';
import { Wrapper, Title, Subtitle, EditButton, Entities } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { setCreationTagModal } from 'Screens/Contextualization/Tags/actions/Actions';
import CheckboxField from '../AdvancedOptions/CheckboxField';
import { setTagsEntityImport } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectHasAssetTags, selectHasServiceTags, selectHasVulnTags } from 'store/ManageEditCreate/selectors';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';

const Tags = ({ tags }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const hasTags = !isEmpty(tags);
  const hasTagsLabel = intl.formatMessage({ id: 'importFileCreationModal.tags.hasTagsSubtitle' });
  const noTagsLabel = intl.formatMessage({ id: 'importFileCreationModal.tags.noTagsSubtitle' });
  const editLabel = intl.formatMessage({ id: 'manage.detail.tab.general.tags.edit' });
  const hasAssetsTags = useSelector(selectHasAssetTags);
  const hasVulnsTags = useSelector(selectHasVulnTags);
  const hasServicesTags = useSelector(selectHasServiceTags);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  if (!hasTagsFeature) return null;

  return (
    <Wrapper>
      <Title children={ intl.formatMessage({ id: 'importFileCreationModal.tags.title' }) } />
      <Subtitle children={ hasTags ? hasTagsLabel : noTagsLabel } />
      <TagItems tags={ tags } />
      <EditButton onClick={ () => dispatch(setCreationTagModal(true, 'import')) }>{ editLabel }</EditButton>
      <Entities>
        <CheckboxField defaultValue={ hasAssetsTags } label="Assets" onChange={ (checked) => dispatch(setTagsEntityImport('assetsTags', checked)) } />
        <CheckboxField defaultValue={ hasVulnsTags } label="Vulnerabilities" onChange={ (checked) => dispatch(setTagsEntityImport('vulnsTags', checked)) } />
        <CheckboxField defaultValue={ hasServicesTags } label="Services" onChange={ (checked) => dispatch(setTagsEntityImport('servicesTags', checked)) } />
      </Entities>

    </Wrapper>
  );
};

export default Tags;
